/**
 * Suitsupply fit-specific size chart data (from suitsupply.com API)
 * Generated by scripts/generate-size-chart-data.mjs – do not edit by hand
 */
const SS_SIZE_CHART_FITS = {
  "jackets": {
    "havana": {
      "title": "Tailored fit – Havana",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61,
              63,
              65
            ]
          },
          {
            "label": "Waist width",
            "values": [
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55,
              57,
              59
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              42,
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              58,
              59,
              59.5,
              60.5,
              61.5,
              62.5,
              63.5,
              64,
              64.5,
              65
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              70,
              71,
              72,
              73,
              74,
              75,
              76,
              77,
              78,
              79
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              50.5,
              52.5,
              54.5,
              56.5,
              58.5,
              60.5,
              62.5,
              64.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              44,
              46,
              48,
              50,
              52,
              54,
              56,
              58
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              62,
              63,
              64,
              65,
              66,
              66.5,
              67.5,
              68.5
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              75,
              76,
              77,
              78,
              79,
              80,
              81,
              82
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              51,
              53,
              55,
              57,
              59,
              61,
              63,
              65
            ]
          },
          {
            "label": "Waist width",
            "values": [
              45,
              47,
              49,
              51,
              53,
              55,
              57,
              59
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              57,
              58,
              59,
              60,
              61,
              61.5,
              62,
              62.5
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              69,
              70,
              71,
              72,
              73,
              74,
              75,
              76
            ]
          }
        ]
      }
    },
    "milano": {
      "title": "Tailored fit – Milano",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              49.5,
              51.5,
              53.5,
              55.5,
              57.5,
              59.5,
              61.5,
              63.5,
              65.5,
              67.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              43,
              45,
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              43,
              44,
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              61.5,
              62,
              63,
              64,
              65,
              66,
              66.5,
              67,
              67.5,
              68
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              74,
              75,
              76,
              77,
              78,
              79,
              80,
              81,
              82,
              83
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              53,
              55,
              57,
              59,
              61,
              63,
              65,
              67
            ]
          },
          {
            "label": "Waist width",
            "values": [
              46,
              48,
              50,
              52,
              54,
              56,
              58,
              60
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              65.5,
              66.5,
              67.5,
              68.5,
              69,
              70,
              71,
              72
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              79,
              80,
              81,
              82,
              83,
              84,
              85,
              86
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              53.5,
              55.5,
              57.5,
              59.5,
              61.5,
              63.5,
              65.5,
              67.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              60.5,
              61.5,
              62.5,
              63.5,
              64,
              64.5,
              65,
              65.5
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              72,
              73,
              74,
              75,
              76,
              77,
              78,
              79
            ]
          }
        ]
      }
    },
    "roma": {
      "title": "Relaxed fit – Roma",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              49.5,
              51.5,
              53.5,
              55.5,
              57.5,
              59.5,
              61.5,
              63.5,
              65.5,
              67.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              43,
              45,
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              45,
              46,
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              57,
              58,
              58.5,
              59.5,
              60.5,
              61.5,
              62.5,
              63,
              63.5,
              64
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              71,
              72,
              73,
              74,
              75,
              76,
              77,
              78,
              79,
              80
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              53.5,
              55.5,
              57.5,
              59.5,
              61.5,
              63.5,
              65.5,
              67.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              61,
              62,
              63,
              64,
              65,
              65.5,
              66.5,
              67.5
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              76,
              77,
              78,
              79,
              80,
              81,
              82,
              83
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Chest width",
            "values": [
              53.5,
              55.5,
              57.5,
              59.5,
              61.5,
              63.5,
              65.5,
              67.5
            ]
          },
          {
            "label": "Waist width",
            "values": [
              47,
              49,
              51,
              53,
              55,
              57,
              59,
              61
            ]
          },
          {
            "label": "Shoulder width",
            "values": [
              47,
              48,
              49,
              50,
              51,
              52,
              53,
              54
            ]
          },
          {
            "label": "Sleeve length",
            "values": [
              56,
              57,
              58,
              59,
              60,
              60.5,
              61,
              61.5
            ]
          },
          {
            "label": "Jacket length",
            "values": [
              70,
              71,
              72,
              73,
              74,
              75,
              76,
              77
            ]
          }
        ]
      }
    }
  },
  "trousers": {
    "vigo": {
      "title": "Slim Leg Tapered - Vigo",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              37,
              39,
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              81,
              82,
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              25.5,
              26.5,
              27.5,
              28.5,
              29,
              30,
              31,
              32,
              33,
              33.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              17,
              17,
              17.5,
              17.5,
              18,
              18.5,
              19,
              19.5,
              20,
              20.5
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              40,
              42,
              44,
              46,
              48,
              50,
              52,
              54
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              87,
              88,
              89,
              90,
              91,
              92,
              93,
              94
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27.5,
              28.5,
              29.5,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              17.5,
              17.5,
              18,
              18.5,
              19,
              19.5,
              20,
              20.5
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              78.5,
              79.5,
              80.5,
              81.5,
              82.5,
              83.5,
              84.5,
              85.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27.5,
              28.5,
              29,
              30,
              31,
              32,
              33,
              33.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              17.5,
              17.5,
              18,
              18.5,
              19,
              19.5,
              20,
              20.5
            ]
          }
        ]
      }
    },
    "brescia": {
      "title": "Slim Leg - Brescia",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              37,
              39,
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              82.5,
              83.5,
              84.5,
              85.5,
              86.5,
              87.5,
              88.5,
              89.5,
              90.5,
              91.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              24.5,
              25.5,
              26.5,
              27,
              28,
              29,
              30,
              31,
              31.5,
              32.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              17.5,
              18,
              18.5,
              19,
              19.5,
              20,
              20.5,
              21,
              21.5,
              22
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              40,
              42,
              44,
              46,
              48,
              50,
              52,
              54
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              88.5,
              89.5,
              90.5,
              91.5,
              92.5,
              93.5,
              94.5,
              95.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              26,
              27,
              28,
              29,
              30,
              30.5,
              31.5,
              32.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              18.5,
              19,
              19.5,
              20,
              20.5,
              21,
              21.5,
              22
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              80,
              81,
              82,
              83,
              84,
              85,
              86,
              87
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              26.5,
              27,
              28,
              29,
              30,
              31,
              31.5,
              32.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              18.5,
              19,
              19.5,
              20,
              20.5,
              21,
              21.5,
              22
            ]
          }
        ]
      }
    },
    "milano-trouser": {
      "title": "Straight Leg - Milano",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              37,
              39,
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90,
              91,
              92
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              26,
              26.5,
              27.5,
              28.5,
              29.5,
              30.5,
              31,
              32,
              33,
              34
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              18.5,
              19,
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              40,
              42,
              44,
              46,
              48,
              50,
              52,
              54
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              90,
              91,
              92,
              93,
              94,
              95,
              96,
              97
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27.5,
              28.5,
              29.5,
              30,
              31,
              32,
              33,
              34
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              80.5,
              81.5,
              82.5,
              83.5,
              84.5,
              85.5,
              86.5,
              87.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27.5,
              28.5,
              29.5,
              30.5,
              31,
              32,
              33,
              34
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      }
    },
    "firenze": {
      "title": "Wide Leg Tapered - Firenze",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              36.5,
              38.5,
              40.5,
              42.5,
              44.5,
              46.5,
              48.5,
              50.5,
              52.5,
              54.5
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              81,
              82,
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27,
              28,
              29,
              30,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5,
              35
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              18.5,
              19,
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              39.5,
              41.5,
              43.5,
              45.5,
              47.5,
              49.5,
              51.5,
              53.5
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              87,
              88,
              89,
              90,
              91,
              92,
              93,
              94
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              28.5,
              29.5,
              30,
              31,
              32,
              33,
              34,
              34.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              40.5,
              42.5,
              44.5,
              46.5,
              48.5,
              50.5,
              52.5,
              54.5
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              78.5,
              79.5,
              80.5,
              81.5,
              82.5,
              83.5,
              84.5,
              85.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              26.5,
              29,
              30,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              19.5,
              20,
              20.5,
              21,
              21.5,
              22,
              22.5,
              23
            ]
          }
        ]
      }
    },
    "duca": {
      "title": "Wide Leg Straight - Duca",
      "lengthRanges": {
        "Long": "> 186 cm",
        "Regular": "168 – 186 cm",
        "Short": "< 168 cm"
      },
      "Regular": {
        "sizes": [
          {
            "num": "42",
            "alpha": "XXS"
          },
          {
            "num": "44",
            "alpha": "XS"
          },
          {
            "num": "46",
            "alpha": "S"
          },
          {
            "num": "48",
            "alpha": "M"
          },
          {
            "num": "50",
            "alpha": "M/L"
          },
          {
            "num": "52",
            "alpha": "L"
          },
          {
            "num": "54",
            "alpha": "XL"
          },
          {
            "num": "56",
            "alpha": "XXL"
          },
          {
            "num": "58",
            "alpha": "3XL"
          },
          {
            "num": "60",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              37,
              39,
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              82,
              83,
              84,
              85,
              86,
              87,
              88,
              89,
              90,
              91
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              27.5,
              28.5,
              29.5,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5,
              35.5,
              36.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              21.5,
              22,
              22.5,
              23,
              23.5,
              24,
              24.5,
              25,
              25.5,
              26
            ]
          }
        ]
      },
      "Long": {
        "sizes": [
          {
            "num": "90",
            "alpha": "S"
          },
          {
            "num": "94",
            "alpha": "M"
          },
          {
            "num": "98",
            "alpha": "M/L"
          },
          {
            "num": "102",
            "alpha": "L"
          },
          {
            "num": "106",
            "alpha": "XL"
          },
          {
            "num": "110",
            "alpha": "XXL"
          },
          {
            "num": "114",
            "alpha": "3XL"
          },
          {
            "num": "118",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              40,
              42,
              44,
              46,
              48,
              50,
              52,
              54
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              88,
              89,
              90,
              91,
              92,
              93,
              94,
              95
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              29.5,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5,
              35.5,
              36.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              22.5,
              23,
              23.5,
              24,
              24.5,
              25,
              25.5,
              26
            ]
          }
        ]
      },
      "Short": {
        "sizes": [
          {
            "num": "23",
            "alpha": "S"
          },
          {
            "num": "24",
            "alpha": "M"
          },
          {
            "num": "25",
            "alpha": "M/L"
          },
          {
            "num": "26",
            "alpha": "L"
          },
          {
            "num": "27",
            "alpha": "XL"
          },
          {
            "num": "28",
            "alpha": "XXL"
          },
          {
            "num": "29",
            "alpha": "3XL"
          },
          {
            "num": "30",
            "alpha": "4XL"
          }
        ],
        "rows": [
          {
            "label": "Waist width",
            "values": [
              41,
              43,
              45,
              47,
              49,
              51,
              53,
              55
            ]
          },
          {
            "label": "Inside leg",
            "values": [
              79.5,
              80.5,
              81.5,
              82.5,
              83.5,
              84.5,
              85.5,
              86.5
            ]
          },
          {
            "label": "Upper leg width",
            "values": [
              29.5,
              30.5,
              31.5,
              32.5,
              33.5,
              34.5,
              35.5,
              36.5
            ]
          },
          {
            "label": "Foot opening width",
            "values": [
              22.5,
              23,
              23.5,
              24,
              24.5,
              25,
              25.5,
              26
            ]
          }
        ]
      }
    }
  }
};

const SS_SIZE_CHART_META = {
  conversions: [
  {
    "eu": "42",
    "alpha": "XXS",
    "usJacket": "32",
    "usTrouser": "26",
    "chinaJacket": "160/84",
    "chinaTrouser": "72"
  },
  {
    "eu": "44",
    "alpha": "XS",
    "usJacket": "34",
    "usTrouser": "28",
    "chinaJacket": "165/88",
    "chinaTrouser": "76"
  },
  {
    "eu": "46",
    "alpha": "S",
    "usJacket": "36",
    "usTrouser": "30",
    "chinaJacket": "170/92",
    "chinaTrouser": "80"
  },
  {
    "eu": "48",
    "alpha": "M",
    "usJacket": "38",
    "usTrouser": "32",
    "chinaJacket": "175/96",
    "chinaTrouser": "84"
  },
  {
    "eu": "50",
    "alpha": "M/L",
    "usJacket": "40",
    "usTrouser": "34",
    "chinaJacket": "180/100",
    "chinaTrouser": "88"
  },
  {
    "eu": "52",
    "alpha": "L",
    "usJacket": "42",
    "usTrouser": "36",
    "chinaJacket": "185/104",
    "chinaTrouser": "92"
  },
  {
    "eu": "54",
    "alpha": "XL",
    "usJacket": "44",
    "usTrouser": "38",
    "chinaJacket": "190/108",
    "chinaTrouser": "96"
  },
  {
    "eu": "56",
    "alpha": "XXL",
    "usJacket": "46",
    "usTrouser": "40",
    "chinaJacket": "195/112",
    "chinaTrouser": "100"
  },
  {
    "eu": "58",
    "alpha": "3XL",
    "usJacket": "48",
    "usTrouser": "42",
    "chinaJacket": "200/116",
    "chinaTrouser": "104"
  },
  {
    "eu": "60",
    "alpha": "4XL",
    "usJacket": "50",
    "usTrouser": "44",
    "chinaJacket": "205/120",
    "chinaTrouser": "108"
  }
],
  shirt: {
  "Regular": {
    "rows": [
      {
        "label": "Chest width",
        "values": [
          91.4,
          94,
          96.5,
          99.1,
          100.3,
          101.6,
          104.1,
          106.7,
          109.2,
          111.8
        ]
      },
      {
        "label": "Waist width",
        "values": [
          76.2,
          78.7,
          81.3,
          83.8,
          85.1,
          86.4,
          88.9,
          91.4,
          94,
          96.5
        ]
      },
      {
        "label": "Sleeve length",
        "values": [
          81.3,
          82.6,
          83.8,
          85.1,
          85.7,
          86.4,
          87.6,
          88.9,
          90.2,
          91.4
        ]
      },
      {
        "label": "Back length",
        "values": [
          73.7,
          74.9,
          76.2,
          77.5,
          78.1,
          78.7,
          80,
          81.3,
          82.6,
          83.8
        ]
      }
    ]
  }
},
  knitwear: {
  "Regular": {
    "rows": [
      {
        "label": "Chest width",
        "values": [
          86.4,
          91.4,
          96.5,
          101.6,
          106.7,
          111.8
        ]
      },
      {
        "label": "Length",
        "values": [
          66,
          68.6,
          71.1,
          73.7,
          76.2,
          78.7
        ]
      }
    ]
  }
},
  shirtSizes: ['14', '14½', '15', '15½', '15¾', '16', '16½', '17', '17½', '18'],
  knitwearSizes: [
    { num: 'XS', alpha: '' },
    { num: 'S', alpha: '' },
    { num: 'M', alpha: '' },
    { num: 'L', alpha: '' },
    { num: 'XL', alpha: '' },
    { num: 'XXL', alpha: '' },
  ],
};
